import React, {useEffect} from "react";
import { AnimatePresence, motion } from "framer-motion";
import {Link} from 'react-router-dom';
import { useCartContext } from "../../../context/cartContext";

//Este componente tiene la animacion de la lista de deseo con su contenido!
export const CuerpoCarrito =({itemWish, removeItemWish})=>{
  useEffect(() => {
  }, [itemWish ])

    return(     
       <div className="cart-inline">
         <div className="cart-inline-header">
           <h5 className="cart-inline-title">Lista de Deseo</h5>
         </div>
         {itemWish .map(x=>
         <div className="cart-inline-body" key={x.id}>
           <div className="cart-inline-item">
             <div className="unit unit-spacing-sm align-items-center">
               <div className="unit-left"><img src={x.imag} className="img-sidebar" alt="producto-carrito"/></div>
               <div className="unit-body">
                 <h6 className="cart-inline-name">{x.description}</h6>
                 <div>
                   <div className="group-xs group-middle">
                     <div className="table-cart-stepper">
                       Und: {x.qty}
                     </div>
                     <h6 className="cart-inline-title">${x.precio}</h6>
                   </div>
                 </div>
               </div>
             </div>
             <button className="btn shop" onClick={()=>removeItemWish(x.id)}><i className="far fa-trash-alt"></i></button>
           </div>
         </div> 
           )}
       </div>
 )
}





const SidebarWish=({ sideBarWish = false, setSideBarWish = () => {} })=> {
    const {itemWish, removeItemWish, deseoAcarrito }= useCartContext();
      return (
        <AnimatePresence>
          {sideBarWish && (
            <>
              <motion.div
                initial={{ x: "100%" }}
                animate={{
                  x: 0
                }}
                exit={{
                  x: "100%"
                }}
                transition={{ type: "spring", bounce: 0, duration: 0.4 }}
                className="abierto"
              >
                <button
                  onClick={() => setSideBarWish((sideBarWish) => !sideBarWish)}
                  className="btn cerrar"
                >
                  &times;
                </button>
                {itemWish.length > 0 ? 
                <><CuerpoCarrito {...{itemWish, removeItemWish}}/>
                <button className="btn_terminar" onClick={() => deseoAcarrito()}>Agregar al Carrito</button></>

                :<>
                <h2 className="text_carrito">Lista Vacia!</h2>
                <Link to={'/'}><button className="btn_terminar" onClick={() => setSideBarWish((sideBarWish) => !sideBarWish)}>Ir Catalogo</button></Link>
                </>}
              </motion.div>
            </>
          )}
        </AnimatePresence>
      );
  }
  export default SidebarWish;